module.exports = __webpack_public_path__ + "img/zncs-sj.c275d744.png";